module.exports = "/images/skipforward.svg?8da7ce62d77565c00eb97f2a4e16586f";